// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img-size[data-v-5f3c946c]{min-width:160px;max-width:160px;height:100px;max-height:-webkit-max-content;max-height:-moz-max-content;max-height:max-content}.list-group-item-action[data-v-5f3c946c]:active,.list-group-item-action[data-v-5f3c946c]:focus,.list-group-item-action[data-v-5f3c946c]:hover{background-color:#fff}.cursor-pointer[data-v-5f3c946c]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
